export const actionTypes = {
    ADD_USER: "ADD_USER",
    DELETE_USER: "DELETE_USER",
    ADD_STEP_ACTIVE: "ADD_STEP_ACTIVE",
    SUBSTRACT_STEP_ACTIVE: "SUBSTRACT_STEP_ACTIVE",
    ADD_SHIFT: "ADD_SHIFT",
    DELETE_SHIFT: "DELETE_SHIFT"
}